// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * VTS state dedup snapshot.
 */
export class StateSnapshot implements flatbuffers.IUnpackableObject<StateSnapshotT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): StateSnapshot {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsStateSnapshot(bb: flatbuffers.ByteBuffer, obj?: StateSnapshot): StateSnapshot {
    return (obj || new StateSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsStateSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: StateSnapshot,
  ): StateSnapshot {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new StateSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  bitmaskStoreSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  onehotStoreSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  forwarded(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  priorActive(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  newActive(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  categoryByte(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  static startStateSnapshot(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addBitmaskStoreSize(builder: flatbuffers.Builder, bitmaskStoreSize: number) {
    builder.addFieldInt32(0, bitmaskStoreSize, 0);
  }

  static addOnehotStoreSize(builder: flatbuffers.Builder, onehotStoreSize: number) {
    builder.addFieldInt32(1, onehotStoreSize, 0);
  }

  static addForwarded(builder: flatbuffers.Builder, forwarded: boolean) {
    builder.addFieldInt8(2, +forwarded, +false);
  }

  static addPriorActive(builder: flatbuffers.Builder, priorActive: boolean) {
    builder.addFieldInt8(3, +priorActive, +false);
  }

  static addNewActive(builder: flatbuffers.Builder, newActive: boolean) {
    builder.addFieldInt8(4, +newActive, +false);
  }

  static addCategoryByte(builder: flatbuffers.Builder, categoryByte: number) {
    builder.addFieldInt8(5, categoryByte, 0);
  }

  static endStateSnapshot(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createStateSnapshot(
    builder: flatbuffers.Builder,
    bitmaskStoreSize: number,
    onehotStoreSize: number,
    forwarded: boolean,
    priorActive: boolean,
    newActive: boolean,
    categoryByte: number,
  ): flatbuffers.Offset {
    StateSnapshot.startStateSnapshot(builder);
    StateSnapshot.addBitmaskStoreSize(builder, bitmaskStoreSize);
    StateSnapshot.addOnehotStoreSize(builder, onehotStoreSize);
    StateSnapshot.addForwarded(builder, forwarded);
    StateSnapshot.addPriorActive(builder, priorActive);
    StateSnapshot.addNewActive(builder, newActive);
    StateSnapshot.addCategoryByte(builder, categoryByte);
    return StateSnapshot.endStateSnapshot(builder);
  }

  unpack(): StateSnapshotT {
    return new StateSnapshotT(
      this.bitmaskStoreSize(),
      this.onehotStoreSize(),
      this.forwarded(),
      this.priorActive(),
      this.newActive(),
      this.categoryByte(),
    );
  }

  unpackTo(_o: StateSnapshotT): void {
    _o.bitmaskStoreSize = this.bitmaskStoreSize();
    _o.onehotStoreSize = this.onehotStoreSize();
    _o.forwarded = this.forwarded();
    _o.priorActive = this.priorActive();
    _o.newActive = this.newActive();
    _o.categoryByte = this.categoryByte();
  }

  unpackFields(...fields: string[]): StateSnapshotT {
    const t = new StateSnapshotT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bitmask_store_size")) {
      t.bitmaskStoreSize = this.bitmaskStoreSize();
    }
    if (fieldSet.has("onehot_store_size")) {
      t.onehotStoreSize = this.onehotStoreSize();
    }
    if (fieldSet.has("forwarded")) {
      t.forwarded = this.forwarded();
    }
    if (fieldSet.has("prior_active")) {
      t.priorActive = this.priorActive();
    }
    if (fieldSet.has("new_active")) {
      t.newActive = this.newActive();
    }
    if (fieldSet.has("category_byte")) {
      t.categoryByte = this.categoryByte();
    }
    return t;
  }
}

export class StateSnapshotT implements flatbuffers.IGeneratedObject {
  constructor(
    public bitmaskStoreSize: number = 0,
    public onehotStoreSize: number = 0,
    public forwarded: boolean = false,
    public priorActive: boolean = false,
    public newActive: boolean = false,
    public categoryByte: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return StateSnapshot.createStateSnapshot(
      builder,
      this.bitmaskStoreSize,
      this.onehotStoreSize,
      this.forwarded,
      this.priorActive,
      this.newActive,
      this.categoryByte,
    );
  }

  clone(): StateSnapshotT {
    const obj = new StateSnapshotT();
    obj.bitmaskStoreSize = this.bitmaskStoreSize;
    obj.onehotStoreSize = this.onehotStoreSize;
    obj.forwarded = this.forwarded;
    obj.priorActive = this.priorActive;
    obj.newActive = this.newActive;
    obj.categoryByte = this.categoryByte;
    return obj;
  }

  equals(other: StateSnapshotT): boolean {
    if (this.bitmaskStoreSize !== other.bitmaskStoreSize) return false;
    if (this.onehotStoreSize !== other.onehotStoreSize) return false;
    if (this.forwarded !== other.forwarded) return false;
    if (this.priorActive !== other.priorActive) return false;
    if (this.newActive !== other.newActive) return false;
    if (this.categoryByte !== other.categoryByte) return false;
    return true;
  }
}

export function verifyStateSnapshot(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
  } finally {
    verifier.popDepth();
  }
}
